namespace('compass.hotel');

compass.hotel.HotelBookingNavWidget = compass.defineWidget(function HotelBookingNavWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	
	var _hotelInfoWidget;

	var _render = this.render = function(widgetElem) {
		var d = _d;

		var tabs = d.div({ className : 'tabs', role : 'tablist' },
			_.map(_settings.tabList, function(elem) {
				var tabAttrs = { 
					className : 'tab '  + elem.navIdentifier.toLowerCase() + 'Tab',
					role : 'tab',
					id : elem.tabId,
					tabindex : 0,
					'aria-controls' : elem.contentId,
					'aria-selected' : false
				};

				var tabEl = d.div(tabAttrs, elem.displayName).activate(function(e){
					// remove the active class 
					var oldTab = me.find('.tab.activeNav');
					oldTab.removeClass('activeNav');
					oldTab.removeClass('disabled');
					oldTab.attr('aria-selected', false);
					
					// add the active class to the item we just clicked on
					tabEl.addClass('activeNav');
					tabEl.attr('aria-selected', true);
								
					// raise the navigationClicked event so that the view/containing widget can respond appropriately
					me.trigger("HotelBookingNavWidget.navigationClicked", elem);
				});

				return tabEl;
			})
		);
		tabs.find('.tab').first().addClass('activeNav');

		widgetElem.append(tabs);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'HotelBookingNavWidget',
	tabList : [ ]
});

